"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERACTION_MAP = {};
exports.getInteraction = function (type) {
    return exports.INTERACTION_MAP[type];
};
exports.registerInteraction = function (type, ctor) {
    // 注册的时候，需要校验 type 重名，不区分大小写
    if (exports.getInteraction(type)) {
        throw new Error("Interaction type '" + type + "' existed.");
    }
    // 存储到 map 中
    exports.INTERACTION_MAP[type] = ctor;
};
//# sourceMappingURL=factory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/interaction/factory.js
// module id = 825
// module chunks = 37